export default "__VITE_ASSET__IPTSM1S0__"